import { Context } from '@nuxt/types'
import { BroadcasterCollectionType } from '~/apiclient/apicollections'
import { siteBroadcasterUrl } from '~/assets/ts/utils/urls'

function GetType(path: string): BroadcasterCollectionType | undefined {
  for (const type of Object.values(BroadcasterCollectionType)) {
    if (path.includes(`${siteBroadcasterUrl()}${type}`)) {
      return type
    }
  }
  return undefined
}

export default async function ({ params, error, store, route }: Context) {
  const type = GetType(route.path)
  const value = type ? params[type] : ''
  if (type) {
    await store.dispatch('collections/fetchBroadcasterCollection', {
      type,
      value,
    })
    const collection = store.getters['collections/broadcasterCollection'](
      type,
      value
    )
    if (collection) return
  }

  error({
    statusCode: 404,
    message: `${type} '${value}' not found`,
  })
}
